import { SHOP_SEARCH_MODE } from '@/enums/shop';
import { useOrientation } from '@/hooks';
import useBaseSize from '@/hooks/useBaseSize';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useFnbStore } from '@/stores';
import ShopFnbFacilitySearchModeButton from '@/components/common/shop-fnb-facility/buttons/search-mode';
import { getHSize } from '@/utils/size';

interface FnbSearchControlProps {
    currentMode: SHOP_SEARCH_MODE;
}

const FnbSearchControl = ({ currentMode }: FnbSearchControlProps) => {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();
    const { baseHeight } = useBaseSize();
    const setCurrentMode = useFnbStore((state) => state.setCurrentMode);
    const updateFnbContents = useFnbStore((state) => state.updateFnbContents);
    const setSearchText = useFnbStore((state) => state.setSearchText);
    const resetFilters = useFnbStore((state) => state.resetFilters);

    const handleChangeMode = (mode: SHOP_SEARCH_MODE) => {
        resetFilters();
        setCurrentMode(mode);
        updateFnbContents(mode);
    };

    return (
        <div
            className={clsx('flex w-full flex-col items-center')}
            style={{ gap: isHorizontal ? getHSize(8, baseHeight) : getHSize(12, baseHeight) }}
            data-region-nav
        >
            <ShopFnbFacilitySearchModeButton
                tabIndex={6}
                fullWidth
                role="radio"
                type="button"
                aria-label={t('fnb.search.tts.control_buttons.search_by_text')}
                title={t('fnb.search.text.control_buttons.search_by_text')}
                onClick={() => {
                    setSearchText('');
                    handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_TEXT);
                }}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_TEXT}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={7}
                fullWidth
                role="radio"
                type='button'
                aria-label={t('fnb.search.tts.control_buttons.search_by_floor')}
                title={t('fnb.search.text.control_buttons.search_by_floor')}
                onClick={() => handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_FLOOR)}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_FLOOR}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={8}
                fullWidth
                role="radio"
                type="button"
                aria-label={t('fnb.search.tts.control_buttons.search_by_category')}
                title={t('fnb.search.text.control_buttons.search_by_category')}
                onClick={() => handleChangeMode(SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY)}
                aria-checked={currentMode === SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY}
                data-interactive
            />
        </div>
    );
};

export default FnbSearchControl;
